export class WorkerRequestError extends Error {
  readonly status?: number;
  readonly code?: string;
  readonly requestId?: string;

  constructor(
    message: string,
    details: { status?: number; code?: string; requestId?: string } = {},
  ) {
    super(message);
    this.name = "WorkerRequestError";
    this.status = details.status;
    this.code = details.code;
    this.requestId = details.requestId;
  }
}
